package io.horion.cv.components.shared

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.CreateCardStyle
import io.horion.cv.styles.CreateCardStylecss
import io.horion.cv.styles.CreateDocumentCardTextStyle
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.CSSLengthOrPercentageValue
import org.jetbrains.compose.web.css.px

@Composable
fun CreateDocumentCard(
    text: String,
    onClick: () -> Unit
) {
    Column(
        modifier = CreateCardStyle.toModifier()
            .then(CreateCardStylecss.toModifier())
//            .width(if (isMobile) 140.px else 280.px)
//            .height( if (isMobile) 185.px else 380.px)
            .borderRadius(8.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() },
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        SpanText(
            text = text,
            modifier = CreateDocumentCardTextStyle.toModifier()
                .fontFamily(INTER)
//                .fontSize(if (isMobile) 13.px else 18.px)
                .fontWeight(FontWeight.Medium)
                .textAlign(TextAlign.Center)
                .padding(leftRight = 12.px)
                .whiteSpace(WhiteSpace.PreWrap)
        )
        SpanText(
            text = "+",
            modifier = Modifier
                .fontSize(32.px)
                .fontWeight(FontWeight.Light)
                .margin(top = 10.px)
        )
    }
}